import { render, staticRenderFns } from "./alert-message.vue?vue&type=template&id=564e3107&scoped=true&"
import script from "./alert-message.vue?vue&type=script&lang=js&"
export * from "./alert-message.vue?vue&type=script&lang=js&"
import style0 from "./alert-message.vue?vue&type=style&index=0&id=564e3107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e3107",
  null
  
)

component.options.__file = "alert-message.vue"
export default component.exports